import { withStyles } from '@mui/styles'
import { Autocomplete } from '@mui/material'

const CustomSelect = withStyles({
  root: {
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderRadius: `25px`,
        borderColor: `#DDDDDD`,
      },
      '& input': {
        borderRadius: `25px`,
        borderColor: `#DDDDDD`,
      },
      borderRadius: `25px`,
      borderColor: `#DDDDDD`,
    },
    paddingRight: `10px`,
  },
})(Autocomplete)

export default CustomSelect
